import { render, staticRenderFns } from "./QuestionMarkHeading.vue?vue&type=template&id=3a340a01&scoped=true&lang=pug&"
import script from "./QuestionMarkHeading.vue?vue&type=script&lang=js&"
export * from "./QuestionMarkHeading.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMarkHeading.vue?vue&type=style&index=0&id=3a340a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a340a01",
  null
  
)

export default component.exports